<template>
    <div class="tx-dealersearch module-map__two-click-solution">
        <div class="module-placeholder module-placeholder--vue">
            <div class="module-placeholder__background" :style="'background-image: url(' + require('@/assets/map-placeholder-portrait.jpg') + '); background-repeat: no-repeat; background-size: cover; background-position: center'"></div>
            <div class="consent__wrapper">
                <div class="consent__text">
                    <span>{{ $t('dealersearch.map.consent.placeholder.textpart1') }}</span>
                    <span>{{ $t('dealersearch.map.consent.placeholder.google') }}</span>
                    <span>{{ $t('dealersearch.map.consent.placeholder.textpart2') }}</span>
                    <a :href="privacy">{{ $t('dealersearch.map.consent.privacy') }}</a>
                    <span>{{ $t('dealersearch.map.consent.placeholder.textpart3') }}</span>
                </div>
                <button class="consent__button -btn-placeholder -button btn -btn-alpha" @click="setConsent">
                    <span><span>{{ $t('dealersearch.map.consent.placeholder.button') }}</span></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      privacy: window.app.dealersearch_list.privacy
    }
  },
  methods: {
    setConsent: function () {
      try {
        window.sessionStorage.setItem('googlemapsConsent', 'consentGiven')
      } catch (error) {
        // The explicit event remains the in-memory consent signal.
      }
      document.dispatchEvent(new CustomEvent('consentGiven', { detail: { service: 'googlemaps' } }))
      this.$emit('giveConsent')
    }
  }
}
</script>
